import { ShieldCheck, ShieldAlert, BadgeCheck } from "lucide-react";

/**
 * `IdVerifiedBadge` sits above the classic `VerifiedBadge`.
 * It represents an organizer who completed ALL 4 layers of self-serve
 * identity verification (legal name + email + phone + government ID +
 * selfie + liveness via Stripe Identity). Manual admin verification
 * unlocks the plain `VerifiedBadge`; this one unlocks itself.
 */
export function IdVerifiedBadge({ compact = false }) {
  return (
    <span
      data-testid="id-verified-badge"
      className="inline-flex items-center gap-1 rounded-full text-[10px] uppercase tracking-widest font-semibold px-2 py-0.5"
      style={{
        backgroundColor: "rgba(132,204,22,0.15)",
        color: "#4B7A0A",
        border: "1.5px solid #84CC16",
      }}
      title="Organizer completed government-ID + selfie + liveness verification"
    >
      <BadgeCheck className="h-3 w-3" />
      {compact ? "ID-Verified" : "ID-Verified organizer"}
    </span>
  );
}

export function VerifiedBadge({ compact = false }) {
  return (
    <span
      data-testid="verified-badge"
      className="inline-flex items-center gap-1 rounded-full text-[10px] uppercase tracking-widest font-semibold px-2 py-0.5"
      style={{ backgroundColor: "rgba(111,125,85,0.12)", color: "var(--moss)" }}
      title="AddVendTour-verified organizer"
    >
      <ShieldCheck className="h-3 w-3" />
      {compact ? "Verified" : "Verified organizer"}
    </span>
  );
}

export function UnverifiedBadge({ compact = false }) {
  return (
    <span
      data-testid="unverified-badge"
      className="inline-flex items-center gap-1 rounded-full text-[10px] uppercase tracking-widest font-semibold px-2 py-0.5"
      style={{ backgroundColor: "rgba(31,93,52,0.12)", color: "var(--terracotta)" }}
      title="This organizer hasn't been verified yet — apply with care."
    >
      <ShieldAlert className="h-3 w-3" />
      {compact ? "Unverified" : "Unverified organizer"}
    </span>
  );
}

/**
 * Priority: ID-Verified (self-serve, highest signal) → Verified (admin) → Unverified.
 * Callers can pass either flag independently; kycApproved wins when both are true.
 */
export default function OrganizerBadge({ verified, kycApproved, compact = false }) {
  if (kycApproved) return <IdVerifiedBadge compact={compact} />;
  return verified ? <VerifiedBadge compact={compact} /> : <UnverifiedBadge compact={compact} />;
}
